import React, { useEffect, useState } from 'react';
import { Button, Checkbox, TextField } from '@mui/material';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { Label } from '@mui/icons-material';
import { assignLabelToUser, getAdminUserLabelList, onlySelectedLabelsList, resetOnlySelectedLabels } from '../redux/actions/userActions';

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        marginTop: '2em'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '40%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    },
};

const AssignLabelsModal = ({ open, onClose, userIds, onLabelsAssigned, isAllUsersSelected, filters, excludedIds, usersCount }) => {
    const dispatch = useDispatch();
    const [selectedLabelIds, setSelectedLabelIds] = useState([]);
    const [removedLabelIds, setRemovedLabelIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    const labelsResponse = useSelector((state) => state.user.adminUserLabels);
    const labels = labelsResponse?.data;
    const userDetails = useSelector((state) => state.user.userDetails);
    const onlySelectedLabels = useSelector(state => state.user.onlySelectedLabels);

    useEffect(() => {
        if (userIds.length == 1) {
            let aJson = {
                "userId": userIds[0],
                "adminUserId": userDetails?.adminUserId
            }
            dispatch(onlySelectedLabelsList(aJson));
        }

        let paramJson = {
            "adminUserId": userDetails?.adminUserId
        }
        dispatch(getAdminUserLabelList(paramJson));

        return () => {
            dispatch(resetOnlySelectedLabels());
        }
    }, []);

    useEffect(() => {
        setSelectedLabelIds(onlySelectedLabels);
    }, [onlySelectedLabels]);

    const handleAssignLabels = async () => {
        if (selectedLabelIds?.length > 0 || removedLabelIds?.length > 0) {

            let payload = {
                "labelIds": selectedLabelIds,
                "removedLabelIds": removedLabelIds
            }

            if (isAllUsersSelected) {
                payload['selectAll'] = true;
                payload['filters'] = filters;
                payload['excludedIds'] = excludedIds;
            } else {
                payload['userIds'] = userIds;
            }

            setIsSaving(true);
            await dispatch(assignLabelToUser(payload));
            setIsSaving(false);
            onLabelsAssigned();
            onClose();
        }
    }

    const handleSelectLabel = (label) => {
        if (selectedLabelIds?.includes(label.id)) {
            setSelectedLabelIds(prevState => prevState.filter(item => item != label.id));
        } else {
            setSelectedLabelIds([...selectedLabelIds, label.id]);

            if (removedLabelIds.includes(label.id)) {
                setRemovedLabelIds(prevState => prevState.filter(item => item != label.id));
            }
        }

        if (onlySelectedLabels?.includes(label.id) && !removedLabelIds.includes(label.id)) {
            setRemovedLabelIds([...removedLabelIds, label.id]);
        }
    }

    return (
        <>
            <ReactModal
                isOpen={open}
                onRequestClose={onClose}
                contentLabel="Assign Label Modal"
                style={customModalStyles}
            >
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Assign Labels:</span>
                        <span style={{ marginLeft: '8px' }}>[<span style={{ color: '#1976d2', fontWeight: 'bold' }}>{usersCount}</span> Users Selected]</span>
                    </div>

                    <div style={{}}>
                        {labels.map((label) =>
                            <div
                                onClick={() => handleSelectLabel(label)}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderRadius: '4px'
                                }}>
                                <Label style={{ color: label.color }} />
                                <div style={{ flex: 1, marginLeft: '8px' }}>
                                    {label.name}
                                </div>
                                <Checkbox
                                    style={{ alignSelf: 'flex-end' }}
                                    size='small'
                                    checked={selectedLabelIds?.some((c) => c === label.id)}
                                />
                            </div>
                        )}
                    </div>

                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ width: '120px' }}
                            size='small'
                            variant='outlined'
                            onClick={onClose}
                        >Cancel</Button>
                        <Button
                            style={{ marginLeft: '12px', width: '120px' }}
                            size='small'
                            variant='contained'
                            onClick={handleAssignLabels}
                            disabled={selectedLabelIds?.length == 0 && removedLabelIds?.length == 0}
                        >{isSaving ? 'Saving' : 'Save'}</Button>

                    </div>

                </div>
            </ReactModal>
        </>
    );
};

export default AssignLabelsModal;
